module.exports = __webpack_public_path__ + "static/flex-cdebde34ae2dd8271389266d9f19cb6b.png";